import { safeClone, ViewStream,  } from "spyne";
import { PageTraits } from "traits/page-traits";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { UiBreadcrumbHolder } from "components/ui/ui-breadcrumb-holder";
import { ScrollSpyTraits } from "traits/scroll-spy-traits";
import { UIBlogLinkView} from 'components/ui/ui-blog-link-view';
import { PageBlogArticleView } from 'components/ui/page-blog-article-view';

import {PageDocsItem} from 'components/pages/page-docs-item';

export class PageBlog extends ViewStream {
  constructor(props = {}) {
    props.traits = [PageTraits, PageLoadDocsTraits, ScrollSpyTraits];
    props.data = safeClone(props.pageData);
    props.id = `l1-${props.pageId}`;
    props.class = "app-page";
    props.initLoaded = false;
    props.scrollOffsetY = 100;
    props.disableScrollSpy = true;
    props.channels = ["CHANNEL_BLOG_DATA_JSON"];
    const len = props.appData.content.length;
    //props.data.appData =  props.appData.content[len-1];

    props.template = require("./templates/page-docs.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"],
      /*
      ["CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT", "pageLoad$OnDocsItemChanged"],
*/
      ["CHANNEL_ROUTE_DEEPLINK_EVENT", "onRouteChannel"],
      ["CHANNEL_ROUTE_CHANGE_EVENT", "onRouteChannel"],
      ["CHANNEL_BLOG_DATA_JSON_RESPONSE_EVENT", "onBlogDataLoaded"],
    ];
  }

  // ChannelFetch caches its response, so late subscribers (this page on
  // any visit after the first fetch) receive the data immediately.
  onBlogDataLoaded(e) {
    this.props.articles = e.payload?.articles ?? [];
    this.renderBlogView();
  }

  onRouteChannel(e){
    const {payload} = e;
    const {routeData} = payload;
    const {section} = routeData;

    // CHANNEL_ROUTE_CHANGE_EVENT can deliver the section polluted with a
    // URL fragment on anchor deep-links ("slug#anchor" — DEEPLINK parses
    // the pathname and arrives clean). The fragment is never part of the
    // section identity; the article view reads location.hash itself for
    // anchor scrolling.


    //console.log("ON ROUTE CHANNEL ",{payload, routeData, section})
    this.props.currentSection = String(section ?? "").split("#")[0];
    this.renderBlogView();
  }

  // Renders once both the fetched articles and the current route are
  // known — whichever arrives second triggers the render. Child views
  // dispose themselves on route changes, so a section change re-renders.
  renderBlogView() {
    const { articles, currentSection } = this.props;

    if (articles === undefined || currentSection === undefined) {
      return;
    }
    // Dedupe only when the content actually exists: route events can
    // repeat a section (anchor deep-links fire DEEPLINK and CHANGE with
    // the same value), and a blind same-section return left the page
    // empty when it fired after the child view had been disposed.
    if (this.props.renderedSection === currentSection) {
      const contentPresent = this.props.el$(
        ".page-content .blog-article, .page-content #blog-menu",
      ).exists;
      if (contentPresent) {
       // return;
      }
    }

    if (currentSection !== "") {
      const article = articles.find(
        (a) => a?.card?.section === currentSection,
      );

      // Unknown section: leave renderedSection unlatched so a later
      // route event with a resolvable section can still render.
      if (article === undefined) {
        return;
      }
      this.props.renderedSection = currentSection;
      this.appendView(
        new PageBlogArticleView({ data: article }),
        ".page-content",
      );
    } else {
      this.props.renderedSection = currentSection;
      const links = articles.map((a) => a.card);

      this.appendView(new UIBlogLinkView({ data: { links } }), ".page-content");
    }
  }


  onDeepLink(e) {
    const onScroll = () => {
      this.page$ScrollSectionIntoView(e, "auto");
    };
    // window.setTimeout(onScroll, 100);
  }

  /* onPageLoaded(e){
    if (this.props.initLoaded === true){

      this.disposeViewStream();
    } else {
      this.props.initLoaded = true;
      this.onDocsItemChanged(e, true);

    }



  }

  enableScrollSpy(){

    this.props.disableScrollSpy = false;
  }




  onDocsItemChanged(e, scrollPageBool){

    const {payload} = e;
    const pageId = payload?.pageId || payload?.routeData?.pageId;
    const {docsDataItem} = payload;
    const {srcEvent} = e?.srcElement;
    const {itemId} = docsDataItem ?? '';
    const checkToNavToItem = ()=> {
     // let itemEl$ = this.props.el$(`#${itemId}`);
      const isScrollPageEvent = scrollPageBool || srcEvent === 'click';

      //console.log('page docs item ', {payload,pageId,isScrollPageEvent, docsDataItem, e, itemId});


      if (isScrollPageEvent === true && pageId==='docs' && itemId !==undefined) {
        //console.log("ITEM IS ",itemEl$.el, {itemEl$})
        const offset = 160;
       // itemEl$.el.scrollIntoView();
       // this.props.disableScrollSpy = true;
        const scrollItem = ()=>{
         let itemEl$ =  this.props.el$(`#${itemId}`);
          //console.log("SCROLL SCTION ",itemEl$.exists === true, itemEl$.el);
          if (itemEl$?.el?.scrollIntoView) {
            itemEl$.el.scrollIntoView({block: "start"});
            window.scrollBy({top: -offset});
            //console.log("SCROLLING INTO VIEW ",itemEl$.el);
            requestAnimationFrame(this.enableScrollSpy.bind(this));
          }

        }
        requestAnimationFrame(scrollItem);
        //itemEl$.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //window.scrollBy({ top: -offset, behavior: 'smooth' });
       // window.setTimeout(this.enableScrollSpy.bind(this), 4000);

      }
    }

    requestAnimationFrame(checkToNavToItem);
  }
*/
  broadcastEvents1() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? ["a", "click"] : [];
    return [broadcastEls];
  }

  /*  addPageDocItems(){
    const {pageId} = this.props;
   //console.log("PAGE IS ",pageId);
    const addPageItems = (data)=>{
     const fn = ()=> this.appendView(new PageDocsItem({data}), '.page-docs-content');
      requestAnimationFrame(fn);
    }

    this.props.data.docsContent.forEach(addPageItems);

  }*/



  addPageDocItems() {
    const addPageItems = (data) => {

      //console.log("DATA INVESTORS IS ", data);
      this.appendView(new PageDocsItem({ data }), ".page-content");
    };

    this.props.appData.blogContent.forEach(addPageItems);
  }


  onRendered() {
    window.scrollTo(0, 0);
    this.addChannel("CHANNEL_APP_ROUTE", true);
    const { docsBreadcrumbData } = this.props;
    /*    this.appendView(new UiBreadcrumbHolder({
      data: docsBreadcrumbData

    }), '.breadcrumb-holder')*/

    this.prependViewToParentEl(
      new UiBreadcrumbHolder({ data: docsBreadcrumbData }),
    );
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();


/*    const links = this.props.data[0]?.links || [];

    this.appendView(new UIBlogLinkView({
      data: {links}


    }), '.page-content');

    this.appendView(new PageBlogArticleView(), '.page-content')


    console.log("BLOG DATA PAGE ",this.props.data[0].links);*/

   // this.pageLoad$AddPageDocItems();

    //this.scrollSpy$SubscribeAndSendToRoute();
    this.addChannel("CHANNEL_ROUTE");



    /*

    const txtData = this.props.data.spyneDocsData.docsContent[0].content[1];
    const theTmpl =3;//
    const textEl = new DomElement({
      class: 'ubu',
      data: txtData,
      template:  `<${txtData.tagName}>{{text}}</${txtData.tagName}><h1>test h1</h1>`,


    }).render();

    this.props.el.appendChild(textEl.querySelector(`div.ubu ${txtData.tagName}`));

   //console.log("this prpos data ",this.props.data.spyneDocsData.docsContent[0].content[1].text);

*/

    // this.appendView(new CodePlaygroundContainer(), "#page-header");
  }
}
